import React from "react";
import logo from "../../images/logo-text-white.png";
import { Link } from "gatsby";
import BackToTop from "./BackToTop";

const Footer = () => {
	return (
		<>
			<div className="footer-area pt-100 pb-75 bg-black">
				<div className="container">
					<div className="row justify-content-center">
						<div className="col-lg-3 col-sm-6 col-md-6">
							<div className="single-footer-widget mb-25">
								<Link to="/" className="logo d-inline-block">
									<img src={logo} alt="logo" />
								</Link>
								<p>
									Your Unity Performance Expert Partner
								</p>
								<ul className="social-links list-unstyled mb-0">
									<li>
										<a
											href="https://facebook.com"
											target="_blank"
											rel="noreferrer"
										>
											<i className="flaticon-facebook"></i>
										</a>
									</li>
									<li>
										<a
											href="https://twitter.com"
											target="_blank"
											rel="noreferrer"
										>
											<i className="flaticon-twitter-1"></i>
										</a>
									</li>
									<li>
										<a
											href="https://instagram.com"
											target="_blank"
											rel="noreferrer"
										>
											<i className="flaticon-instagram-1"></i>
										</a>
									</li>
									<li>
										<a
											href="https://linkedin.com"
											target="_blank"
											rel="noreferrer"
										>
											<i className="flaticon-linkedin-1"></i>
										</a>
									</li>
								</ul>
							</div>
						</div>
						<div className="col-lg-3 col-sm-6 col-md-6">
							<div className="single-footer-widget mb-25 ps-xl-5">
								<h4>Quick Links</h4>
								<ul className="custom-links">
									<li>
										<Link to="/">Home</Link>
									</li>
									<li>
										<Link to="https://thegamedev.guru/">Blog</Link>
									</li>
									<li>
										<Link to="https://www.youtube.com/channel/@TheGameDevGuru">YouTube</Link>
									</li>
									<li>
										<Link to="/">Contact</Link>
									</li>
								</ul>
							</div>
						</div>
						<div className="col-lg-3 col-sm-6 col-md-6">
							<div className="single-footer-widget mb-25">
								<h4>Get In Touch</h4>
								<ul className="footer-contact-info">
									<li>
										<i className="bx bx-envelope"></i>
										<a href="mailto:ruben@PerformanceLabs.net">
											ruben@PerformanceLabs.net
										</a>
									</li>
									<li>
										<i className="bx bx-phone-call"></i>
										<a href="tel:+34644469442">
											+34 644 469 442
										</a>
									</li>
									<li>
										<i className="bx bx-map"></i>
										Paseo de la Castellana 194, Planta baja, Puerta B, 28046 MADRID, Spain
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="copyright-area text-center">
				<div className="container">
					<p>
						© Performance Labs SL 2023
					</p>
				</div>
			</div>
			<BackToTop />
		</>
	);
};

export default Footer;
